import { render, staticRenderFns } from "./LessonPlans.vue?vue&type=template&id=87367768"
import script from "./LessonPlans.vue?vue&type=script&lang=js"
export * from "./LessonPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports